import React, { Component } from 'react'
import store from '../../../../store'
import './sideMenu.less'
import logoNew from '../../../../static/images/logo-new.png'
import { Menu } from 'antd';

const SubMenu = Menu.SubMenu;
const storeData = store.getState().userData
// const { access } = storeData

class SideMenu extends Component {
    state = {
        current: `menu${this.props.menuList[0].path}`,
        // showedMenuList: []
    }

    componentDidMount(props) {
        const str = window.location.pathname
        this.setState({
            current: `menu${str}`,
        });

        // let { menuList } = this.props
        // let haveChildren = false
        // menuList.forEach((list) => {
        //     if (list.childRoutes && list.childRoutes.length > 0) {
        //         list.childRoutes.forEach(children => {
        //             if (children.path) {
        //                 haveChildren = true
        //             }
        //         })
        //         let showedMenuList = []
        //         if (haveChildren) {
        //             showedMenuList = this.getMenuList(list.childRoutes)
        //         } else {
        //             showedMenuList = (
        //                 <Menu.Item key={`menu${list.path}`} >
        //                     {<span>{list.meta.title || '无标题'}</span>}
        //                 </Menu.Item>
        //             )
        //         }
        //         this.setState({
        //             showedMenuList
        //         })
        //     }
        // })

    }


    getMenuList(menuList) {   //递归获取子菜单
        return menuList.map((item, index) => {
            if (!item.path) {
                return ''
            }
            let haveChildren = false
            if (item.childRoutes && item.childRoutes.length > 0) {
                item.childRoutes.forEach(children => {
                    if (children.path) {
                        haveChildren = true
                    }
                })
            }
            if (haveChildren) {
                return (
                    <SubMenu key={`menu${item.path}`} title={<span>{item.meta.title}</span>}>
                        {item.childRoutes.map(itemChildren => {
                            if (itemChildren.childRoutes && itemChildren.childRoutes.length > 0) {
                                return this.getMenuList(itemChildren)
                            } else {
                                return (
                                    <Menu.Item key={`menu${itemChildren.path}`}>{itemChildren.meta.title || '无标题'}</Menu.Item>
                                )
                            }
                        })}
                    </SubMenu>
                )
            } else {
                return (
                    <Menu.Item key={`menu${item.path}`} >
                        {<span>{item.meta.title || '无标题'}</span>}
                    </Menu.Item>
                )
            }
        })
    }
    handleClick(e) {

        this.setState({
            current: e.key,
        });
        let router = ''
        e.keyPath.reverse()
        if (e.keyPath.length > 1) {
            router = e.keyPath[1]
        } else {
            router = e.keyPath[0]
        }
        router = router.replace(/menu/g, '')
        if (router.indexOf("/") !== 0) {
            router = "/" + router
        }
        this.props.changeRouter(router)
    }//获取菜单点击事件

    goLogin = () => {
        // if (this.props.changeRouter) {
        //     this.props.changeRouter('/login')
        // }
        window.location.href = 'https://ht.yuemiaoai.com/#/user/login';
    }

     goRegister = () => {
        // if (this.props.changeRouter) {
        //     this.props.changeRouter('/register')
        // }
        window.location.href = 'https://ht.yuemiaoai.com/#/user/register';
    }

    render() {
        let { current } = this.state
        return (
            <div className="side-menu-wrapper">
                <img className="logo" src={logoNew} alt="" />
                <Menu onClick={this.handleClick.bind(this)} defaultSelectedKeys={[current]} selectedKeys={[current]} mode="horizontal" ref="menu">
                    {
                        this.props.menuList && this.props.menuList.length > 0 && this.props.menuList.map((item, index) => {

                            if (item.childRoutes) {
                                return (
                                    <Menu.SubMenu title={<span>{item.meta.title}</span>} key={index}>
                                        {item.childRoutes.map((itemChildren) => {
                                            return (
                                                <Menu.Item key={`menu${itemChildren.path}`}>
                                                    {<span>{itemChildren.meta.title || '无标题'}</span>}
                                                </Menu.Item>
                                            )
                                        })}
                                    </Menu.SubMenu>
                                )
                               
                            } else {
                                if (!item.meta.hideInMenu) {
                                    return (
                                        <Menu.Item key={`menu${item.path}`} >
                                            {<span>{item.meta.title|| '无标题'}</span>}
                                        </Menu.Item>
                                    )
                                }
                                
                            }

                            }
                        )
                    }

                </Menu>
                <div className="login-btn" >
                    <span onClick={this.goLogin} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && this.goLogin()}>登录</span>
                    <span style={{ margin: '0 10px' }}>|</span>
                    <span onClick={this.goRegister} role="button" tabIndex={0} onKeyDown={(e) => e.key === 'Enter' && this.goRegister()}>注册</span>
                </div>
            </div>
        )
    }
}

export default SideMenu